<div class="blog-promo-sections">
  <div *ngIf="loading" class="loading-state">Loading...</div>
  
  <div *ngFor="let section of sections" class="promo-section">
    <builder-content
      [model]="model"
      [content]="section"
      [apiKey]="apiKey">
    </builder-content>
  </div>
</div>

